import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './PaymentFailed.module.css'; // Import the CSS module

const PaymentFailed = () => {
    const navigate = useNavigate();

    return (
        <div className={styles['payment-failed']}>
            <h2>Payment Verification Failed</h2>
            <p>We were unable to verify your payment. Please try again or contact support for assistance.</p>
            <button onClick={() => navigate('/')}>Go to Homepage</button>
        </div>
    );
};

export default PaymentFailed;
